<template>
    <div class="p-8">
      <v-progress-linear v-if="loading" color="secondary" height="6" indeterminate rounded></v-progress-linear>
      <v-form ref="form" 
      v-model="valid" 
      lazy-validation
      >
        <v-card
          class="pa-4"
          v-if="newcmp"
        >

            <v-card-title>
              Nueva Comunicación
            </v-card-title>

            <v-card-subtitle>
              Formulario para la creación de nuevas comunicaciones
            </v-card-subtitle>

          <v-card-text class="bg-surface-light pt-4">
            <v-row>
              <v-col cols="2">
                <v-text-field
                    label="Orden Id"
                    prefix="CMP-"
                    v-model="OrdenItem.RepOrder_id"
                    placeholder="1"
                    outlined
                    readonly
                  ></v-text-field>
              </v-col>
              <v-col cols="6">
                <v-text-field
                  label="Descripción"
                  v-model="OrdenItem.RepOrder_Desc"
                  placeholder="Descripción"
                  outlined
                  required
                  :rules="[v => !!v || 'Descripción requerida']"
                ></v-text-field>
              </v-col>
              <v-col cols="4">
                <v-text-field
                  label="Fecha"
                  v-model="OrdenItem.CreationRepEvent_Dt"
                  placeholder="9999-12-31"
                  outlined
                  readonly
                ></v-text-field>
              </v-col>
            </v-row>
            <v-divider></v-divider>
            <v-row>
              <v-col cols="4">
                <v-autocomplete v-model="RepOrderTemplate2.RepOrderTemplate2_id"
                :items="RepOrderTemplate"
                :item-text="'RepOrderTemplate_Desc'"
                :item-value="'RepOrderTemplate_id'"
                label="Plantilla"
                outlined
                required
                :rules="[v => !!v || 'Este campo es requerido']"
                @change="updateDescription"
                ></v-autocomplete>
              </v-col>
              <v-col cols="6">
                 <v-file-input v-model="files"
                    outlined
                    accept=".xlsx"
                    label="Archivo excel"
                    placeholder="Seleccione su archivo"
                    name="file"  
                    id="file"
                    required
                    :rules="[v => !!v || 'Archivo requerido']"></v-file-input>
              </v-col>
              <v-col cols="2" sm="2" md="2">
                <v-btn :disabled="files.length == 0 || RepOrderTemplate2.RepOrderTemplate2_id == 0 || OrdenItem.RepOrder_Desc == '' || !valid" color="primary" @click="carga">Cargar</v-btn>
              </v-col>
            </v-row>
            <v-divider></v-divider>
            <v-row>
              <v-col>
                <v-tabs v-model="tabs" grow v-if="mostrarTabs">
                  <v-tab
                    v-for="(item, index) in items"
                    :key="index"
                    :class="taberror === true && item.text === 'Errores' ? 'tab-active' : 'tab-inactive'"
                  >
                    <v-icon left class="mr-2">{{ item.icon }}</v-icon>
                    {{ item.text }}
                  </v-tab>
                </v-tabs>

                <v-tabs-items v-model="tabs" v-if="mostrarTabs">
                  <!-- Tab 1 -->
                  <v-tab-item>
                    <v-card flat>
                      <v-card-text>
                        <v-row class="mb-4" align="center" justify="space-between">
                          <v-col cols="auto" class="d-flex justify-end">
                          </v-col>
                          <v-col cols="auto">
                            <v-btn v-if="this.destinatarios.length > 0" color="primary" dark class="ml-4" @click="exportarExcelCarga">
                              <v-icon left>mdi-file-excel</v-icon>
                              Exportar
                            </v-btn>
                            <v-btn color="primary" dark class="ml-4" @click="newtItem">
                              <v-icon left>mdi-plus</v-icon>
                              Agregar nuevo
                            </v-btn>
                          </v-col>
                        </v-row>
                        <v-dialog v-model="dialog" max-width="900px">
                          <v-card>
                            <div v-if="loading2">
                                <v-progress-linear  color="secondary" height="6" indeterminate rounded></v-progress-linear>
                            </div>
                            <v-card-title>
                              <span class="headline">Nuevo Usuario</span>
                            </v-card-title>

                            <v-card-text>
                              <v-container>
                                <v-form
                                  ref="form"
                                  v-model="valid2"
                                  lazy-validation
                                >
                                <v-text-field v-model="editedItem.ApiUser_id" variant="solo-filled" 
                                label="Usuario" required readonly v-show="true"></v-text-field>
                                <v-text-field v-model="editedItem.ApiUserType_id" variant="solo-filled" 
                                label="Tipo Usuario" required readonly v-show="false"></v-text-field>
                                <v-text-field v-model="editedItemS.ApiUser_id" variant="solo-filled" 
                                label="Usuario" required readonly v-show="false"></v-text-field>
                                <v-text-field v-model="editedItemS.SupplierStart_Dt" variant="solo-filled" 
                                label="Fecha Inicio" required readonly v-show="false"></v-text-field>
                                <v-text-field v-model="editedItemS.SupplierEnd_Dt" variant="solo-filled" 
                                label="Fecha Fin" required readonly v-show="false"></v-text-field>
                                <v-row>
                                  <v-col cols="3" >
                                    <v-text-field v-model="editedItem.ApiUser_GivenName" :rules="descRules" label="Nombre"
                                              variant="solo-filled" required @input="nombreCompleto"></v-text-field>
                                  </v-col> 
                                  <v-col cols="6">
                                    <v-text-field
                                      v-model="editedItem.ApiUser_EMail"
                                      :rules="emailRules"
                                      label="Correo electrónico"
                                      required
                                      variant="solo-filled"
                                    />
                                  </v-col> 
                                </v-row>
                                <v-row>
                                  <v-col cols="6">
                                    <v-autocomplete v-model="editedItemS.ApiUser_Supplier"
                                    :items="proveedores"
                                    :item-text="mostrarProveedor"
                                    :item-value="'MotherSupplier_id'"
                                    label="Proveedor"
                                    outlined
                                    chips
                                    multiple
                                    ></v-autocomplete>
                                    <!-- @change="agregarProducto"-->
                                  </v-col>
                                </v-row>
                                </v-form>
                              </v-container>
                            </v-card-text>

                            <v-card-actions>
                              <v-spacer></v-spacer>
                              <v-btn color="primary" text @click="close">Cancel</v-btn>
                              <v-btn :disabled="!valid2" color="accent" text @click="save">Guardar</v-btn>
                            </v-card-actions>
                          </v-card>
                        </v-dialog>
                        <v-row class="mb-4" align="center" justify="space-between">
                          <v-col cols="auto" class="d-flex justify-end">
                          </v-col>
                          <v-col cols="6">
                            <v-text-field
                              v-model="search"
                              append-icon="mdi-magnify"
                              label="Buscar"
                              single-line
                              hide-details
                            />
                          </v-col>
                        </v-row>
                        
                        <v-data-table
                          :headers="headers1"
                          :items="destinatarios"
                          :search="search"
                          item-key="idCompuesta"
                          class="elevation-1"
                        >
                        <template v-slot:header.selected="{ props }">
                          <v-checkbox
                          v-model="selectAll"
                          label=""
                          @change="toggleSeleccionarTodo"
                          />
                        </template>
                        <template v-slot:item.selected="{ item }">
                          <v-checkbox
                            v-model="item.selected"
                            color="primary"
                            hide-details
                            
                          ></v-checkbox>
                        </template>
                        </v-data-table>
                      </v-card-text>
                    </v-card>
                  </v-tab-item>

                  <!-- Tab 2 -->
                  <v-tab-item color="primary">
                    <v-card flat>
                      <v-card-text>
                        <v-data-table
                          :headers="headers2"
                          :items="data2"
                          class="elevation-1"
                          header-class="custom-header"
                        ></v-data-table>
                      </v-card-text>
                    </v-card>
                  </v-tab-item>

                  <!-- Tab 3 -->
                  <v-tab-item v-if="headers6.length && data3.length" color="primary">
                    <v-card flat>
                      <v-card-text>
                        <v-data-table
                          :headers="headers6"
                          :items="data3"
                          class="elevation-1"
                          header-class="custom-header"
                        ></v-data-table>
                      </v-card-text>
                    </v-card>
                  </v-tab-item>

                  <!-- Tab 4 -->
                  <v-tab-item>
                    <v-card flat>
                      <v-card-text>
                        <v-textarea
                          label="Contenido de la Comunicación"
                          rows="10"
                          v-model="OrdenItem.RepOrder_Text"
                          outlined
                        ></v-textarea>
                      </v-card-text>
                    </v-card>
                  </v-tab-item>

                  <!-- Tab 5 -->
                  <v-tab-item>
                    <v-card flat>
                      <v-card-text>
                        <v-data-table
                          :headers="headers3"
                          :items="errores"
                          class="elevation-1"
                          header-class="custom-header"
                        ></v-data-table>
                      </v-card-text>
                    </v-card>
                  </v-tab-item>
                </v-tabs-items>
              </v-col>
            </v-row>
          </v-card-text>
          <v-row>
            <v-col cols="auto">
              <v-btn rounded="" block align="center" color="primary" @click="listaCMP">Lista De Comunicaciones</v-btn>
            </v-col>
            <v-col  cols="auto">
              <v-btn rounded="" :disabled="btnG" block :loading="loading" align="center" color="primary"  @click="GenerarCMP('/SendMailCMP2')">Generar</v-btn>
            </v-col>

            <v-col cols="auto" v-if="esPreprod">
              <v-btn rounded="" :disabled="btnG" block :loading="loading" align="center" color="warning" @click="GenerarCMP('/SendMailCMP2Simulado')">
                <v-icon left>mdi-test-tube</v-icon>
                Generar Simulado
              </v-btn>
            </v-col>
          </v-row>
          
        </v-card>
        <v-divider></v-divider>
    </v-form>
        <v-card
          class="pa-4 mt-4"
          v-if="listOr"
        >
         
            <v-card-title>
              Lista Comunicación
            </v-card-title>

            <v-card-subtitle>
              Lista de Comunicaciones enviadas.
            </v-card-subtitle>

          <v-card-text class="bg-surface-light pt-4">
            <v-row class="mb-4" align="center" justify="space-between">
              <v-col cols="auto" class="d-flex justify-end">
              </v-col>
              <v-col cols="auto">
                <v-btn v-if="this.proveedores.length > 0" color="primary" dark class="ml-4" @click="exportarExcelOrdenes">
                  <v-icon left>mdi-file-excel</v-icon>
                  Exportar
                </v-btn>
                <v-btn color="primary" dark class="ml-4" @click="agregarNuevo">
                  <v-icon left>mdi-plus</v-icon>
                  Agregar nuevo
                </v-btn>
              </v-col>
            </v-row>
            <!-- Filtros -->
            <v-row class="mb-4" dense>
              <v-col v-for="column in headers" :key="column.value" v-if="column.value !== 'action'" cols="2">
                <v-text-field
                v-model="filters[column.value]"
                :label="'Filtrar ' + column.title"
                dense
                hide-details
                outlined
                />
              </v-col>
              </v-row>
              <v-data-table
              :headers="headers"
              :items="filteredItems"
              item-key="RepOrder_id"
              show-expand
              class="elevation-1"
            >
              <template v-slot:item.RepOrderStatus_id="{ item }">
                <v-chip
                  v-if="getRepOrderStatus(item.RepOrderStatus_id).RepOrderStatus_Color"
                  :color="getRepOrderStatus(item.RepOrderStatus_id).RepOrderStatus_Color"
                  :border="`${getRepOrderStatus(item.RepOrderStatus_id).RepOrderStatus_Color} thin opacity-10`"
                  size="small"
                >
                  {{ getRepOrderStatus(item.RepOrderStatus_id).RepOrderStatus_Desc }}
                </v-chip>
              </template>
              <!-- Fila expandida -->
              <template v-slot:expanded-item="{ headers, item }">
                <td :colspan="headers.length">
                  <v-simple-table dense class="ml-6">
                    <thead>
                      <tr>
                        <th>Orden ID</th>
                        <th>Proveedor</th>
                        <th>Status</th>
                        <th>Fecha Status</th>
                        <th>Hora Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(sub, index) in getSubitems(item.RepOrder_id)" :key="index">
                        <td>{{ sub.RepOrder_id }}</td>
                        <td>{{ mostrarProveedor(getSupplier(sub.MotherSupplier_id)) }}</td>
                        <td>
                          <v-chip
                            :color="getRepOrderItemsStatus(sub.RepOrderItemsStatus_id).RepOrderItemsStatus_Color"
                            text-color="black"
                            class="ma-1"
                            size="small"
                            variant="flat"
                            pill
                          >
                            {{ getRepOrderItemsStatus(sub.RepOrderItemsStatus_id).RepOrderItemsStatus_Desc }}
                          </v-chip>
                        </td>
                        <td>{{ sub.RepEvent_Dt }}</td>
                        <td>{{ sub.RepEvent_Tm }}</td>
                      </tr>
                    </tbody>
                  </v-simple-table>
                </td>
              </template>
              <template v-slot:item.action="{ item }">
                <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    small
                    class="mr-2"
                    v-bind="attrs"
                    v-on="on"
                    @click="GetRepOrder(item)"
                  >
                    mdi-eye
                  </v-icon><!--editOrder(item)-->
                  </template>
                  <span>Ver Detalle</span>
                  </v-tooltip>
                  <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    small
                    class="mr-2"
                    v-bind="attrs"
                    v-on="on"
                    v-if="item.RepOrderStatus_id !== 5"
                    @click="onCancel(item)"
                  >
                    mdi-checkbox-marked-outline
                  </v-icon>
                  </template>
                  <span>Finalizar</span>
                  </v-tooltip>
                
                  <v-tooltip bottom v-if="debeVerReenvio(item)">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                        small
                        class="mr-2"
                        v-bind="attrs"
                        v-on="on"
                        @click="abrirReenvio(item)"
                      >
                        mdi-email-sync-outline
                      </v-icon>
                    </template>
                    <span>Reenviar Mail</span>
                  </v-tooltip>
              </template>
            </v-data-table>
              <!-- <v-data-table
              :headers="headers"
              :items="filteredItems"
              item-value="name"
              class="elevation-1"
              >
              <template #item="{ item }">
                <tr>
                  <td>{{ item.RepGroup_id }}</td>
                  <td>{{ item.EffectiveDate }}</td>
                  <td>{{ item.ExpirationDate }}</td>
                  <td>{{ item.LastOpRepUser_id }}</td>
                  <td>{{ item.RepEvent_Dt }}</td>
                  <td>{{ item.RepEvent_Tm }}</td>
                </tr>
              </template>
            </v-data-table>  -->
            <!-- Botón de exportación -->

          </v-card-text>
        </v-card>

        <!-- <v-textarea
                          v-model="OrdenItem.RepOrder_Text"
                          label="Contenido"
                          auto-grow
                          outlined
                        />  -->
        <!-- <v-autocomplete v-model="ReceiversItem.MotherSupplier_id"
          :items="proveedores"
          :item-text="'MotherSupplier_Desc'"
          :item-value="'MotherSupplier_id'"
          label="Proveedores"
          multiple
          outlined
          chips
          @change="agregarProducto"
          ></v-autocomplete>

          <v-data-table
            :items="itemsEnTabla"
            :headers="headers"
            class="mt-4"
          ></v-data-table> -->

      <v-dialog v-model="dialog_new" max-width="900px">
      <v-stepper v-model="e1" vertical>
            <p align="right"><v-btn color="blue darken-1" text @click="close">X</v-btn></p>
            <v-stepper-step :complete="e1 > 1" step="1" :rules="[value => !! step_error1]" :color="step_color1">Generando Comunicación
                <small>Generando Comunicación: {{this.OrdenItem.RepOrder_id}} - {{ this.OrdenItem.RepOrder_Desc }}</small>
            </v-stepper-step>
            <v-stepper-content step="1">
            <v-card height="100px">
                <div class="text-center">
                <v-progress-circular v-if="progressBar1" indeterminate size="64" color="primary"></v-progress-circular><br>
                {{this.msj_proceso}}
                </div>
            </v-card>
            </v-stepper-content>
    
            <v-stepper-step :complete="e1 > 2" step="2" :rules="[value => !! step_error2]" :color="step_color2">Registrando Destinatarios
                <small>Asignando datos con el destinatario</small>
            </v-stepper-step>
            <v-stepper-content step="2">
            <v-card height="100px">
                <div class="text-center">
                <v-progress-circular v-if="progressBar1" indeterminate size="64" color="primary"></v-progress-circular><br>
                {{this.msj_proceso}}
                </div>
            </v-card>
            </v-stepper-content>

            <v-stepper-step :complete="e1 > 3" step="3" :rules="[value => !! step_error3]" :color="step_color3">Finalizando Comunicación
                <small>Validando la Comunicación creada </small>
            </v-stepper-step>
            <v-stepper-content step="3">
            <v-card height="100px">
                <div class="text-center">
                <v-progress-circular v-if="progressBar1" indeterminate size="64" color="primary"></v-progress-circular><br>
                <pre>{{this.msj_proceso}}</pre>
                </div>
            </v-card>
            </v-stepper-content>
            
        </v-stepper>
      </v-dialog>
      <v-dialog v-model="viewrepo" max-width="900px">
        <v-card>
          <v-card-title class="d-flex justify-space-between align-center">
          <span>Detalle de Orden</span>
          <v-btn icon @click="viewrepo = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-divider></v-divider>
        <v-card-text>
        <v-stepper v-model="e2" class="mb-10">
                    <v-stepper-header>
                        <v-stepper-step step="1" :complete="e2 > 1">Enviado</v-stepper-step>

                        <v-divider></v-divider>

                        <v-stepper-step step="2" :complete="e2 > 2">Pendiente</v-stepper-step>

                        <v-divider></v-divider>

                        <v-stepper-step step="3" :complete="e2 > 3">En Proceso</v-stepper-step>
                        <v-divider></v-divider>

                        <v-stepper-step step="4" :complete="e2 > 4">En Observación</v-stepper-step>
                        <v-divider></v-divider>

                        <v-stepper-step step="5" :complete="e2 == 5">Finalizado</v-stepper-step>
                    </v-stepper-header>
                </v-stepper>

                <v-divider />
                <v-form ref="form">
                    <v-card variant="flat">
                      <v-card-subtitle class="f-w-800">Orden</v-card-subtitle>
                        <v-card-text>
                          <v-row>
                            <v-col cols="2">
                              <v-text-field
                                  label="Orden Id"
                                  prefix="CMP-"
                                  v-model="RepOrder2.RepOrder_id"
                                  placeholder="1"
                                  outlined
                                  readonly
                                ></v-text-field>
                            </v-col>
                            <v-col cols="6">
                              <v-text-field
                                label="Descripción"
                                v-model="RepOrder2.RepOrder_Desc"
                                placeholder="Descripción"
                                outlined
                                readonly
                                :rules="[v => !!v || 'Descripción requerida']"
                              ></v-text-field>
                            </v-col>
                            <v-col cols="2">
                              <v-text-field
                                label="Fecha"
                                v-model="RepOrder2.CreationRepEvent_Dt"
                                outlined
                                readonly
                              ></v-text-field>
                            </v-col>
                            <v-col cols="2">
                              <v-text-field
                                label="Usuario"
                                v-model="RepOrder2.CreationRepUser_id"
                                placeholder="9999-12-31"
                                outlined
                                readonly
                              ></v-text-field>
                            </v-col>
                          </v-row>
                        </v-card-text>
                    </v-card>
                    <v-divider class="my-5" />

                    <v-card variant="flat">
                        <v-card-subtitle class="f-w-800">Proveedores</v-card-subtitle>
                        <v-card-text>
                        <v-sheet rounded="0" border>
                          <v-data-table
                          :headers="headers4"
                          :items="subitems2"
                          item-key="MotherSupplier_id"
                          class="elevation-1"
                          show-expand
                          header-class="custom-header"
                        >
                        <template v-slot:item.RepOrderItemsStatus_id="{ item }">
                          <v-chip
                            v-if="getRepOrderItemsStatus(item.RepOrderItemsStatus_id).RepOrderItemsStatus_Color"
                            :color="getRepOrderItemsStatus(item.RepOrderItemsStatus_id).RepOrderItemsStatus_Color"
                            :border="`${getRepOrderItemsStatus(item.RepOrderItemsStatus_id).RepOrderItemsStatus_Color} thin opacity-10`"
                            size="small"
                          >
                            {{ getRepOrderItemsStatus(item.RepOrderItemsStatus_id).RepOrderItemsStatus_Desc }}
                          </v-chip>
                        </template>
                        <template v-slot:item.MotherSupplier_Desc="{ item }">
                          <span>{{ getSupplier(item.MotherSupplier_id).MotherSupplier_Desc }}</span>
                        </template>
                        <template v-slot:expanded-item="{ headers, item }">
                          <td :colspan="headers.length">
                            <v-expand-transition>
                              <div v-if="item.RepOrderItemsStatus_id > 2">
                                <v-card class="pa-4 mt-2" elevation="2" color="#FAFAFA">
                                  <v-form>
                                  <v-textarea
                                    v-model="respuesta"
                                    label="Escribe tu respuesta"
                                    outlined
                                    auto-grow
                                    rows="2"
                                  />
                                  <v-col cols="6">
                                  <v-file-input v-model="files2"
                                      outlined
                                      accept=".xlsx"
                                      label="Archivo excel"
                                      placeholder="Seleccione su archivo"
                                      name="file2"  
                                      id="file2"
                                      required
                                      :rules="[v => !!v || 'Archivo requerido']"></v-file-input>
                                </v-col>
                                  <div class="text-right mt-2">
                                    <v-btn
                                      color="success"
                                      :loading="loading"
                                      @click="() => enviarRespuesta(item.MotherSupplier_id,RepOrder2)"
                                      small
                                    >
                                      <v-icon left>mdi-send</v-icon>
                                      Enviar
                                    </v-btn>
                                  </div>
                                  </v-form>
                                </v-card>
                              </div>
                            </v-expand-transition>
                          </td>
                        </template>
                        </v-data-table>
                        </v-sheet>
                        </v-card-text>
                    </v-card>
                    <v-divider class="my-5" />
                    <v-card variant="flat">
                        <v-card-subtitle class="f-w-800">Movimientos</v-card-subtitle>
                        <v-card-text>
                      <v-sheet rounded="" border>
                        <v-data-table
                          :headers="headers5"
                          :items="RepOrderItems"
                          class="elevation-1"
                          header-class="custom-header"
                        ></v-data-table>
                    </v-sheet>
                    </v-card-text>
                    </v-card>

                    <v-divider class="my-5" />

                    <v-row justify="end">
                      <v-col cols="6" lg="2" md="6" sm="12" justify="end" class="">
                          <div class="d-flex ga-6 mt-8 justify-end">
                              <!--<v-btn color="secondary" variant="flat" @click="volver">Regresar</v-btn>-->
                          </div>
                      </v-col>
                      <v-col cols="auto" v-if="e2 < 5">
                        <div class="d-flex mt-8 justify-end">
                          <v-btn
                            @click="onCancel(RepOrder2)"
                            color="primary"
                            variant="outlined"
                          >
                            Finalizar
                          </v-btn>

                          <v-btn
                            @click="abrirReenvio(RepOrder2)"
                            v-if="e2 === 1 && ordenesConDatos.includes(RepOrder2.RepOrder_id)"
                            color="secondary"
                            variant="outlined"
                          >
                            Reenviar Mail
                          </v-btn>
                        </div>
                      </v-col>
                    </v-row>
                </v-form>
        <!--<RepOrderView :id="this.RepOrder.RepOrder_id"/>-->
        </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialog_reenvio" max-width="500px">
        <v-card>
          <v-card-title>
            Reenviar Mail — CMP-{{ itemReenvio ? itemReenvio.RepOrder_id : '' }}
          </v-card-title>
          <v-card-subtitle>
            Se reenviarán los mails con los datos originales de la comunicación.
          </v-card-subtitle>
          <v-card-text>
            <v-alert v-if="msj_reenvio" :type="msj_reenvio_type" dense text class="mt-2">
              {{ msj_reenvio }}
            </v-alert>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="dialog_reenvio = false">Cancelar</v-btn>
            <v-btn
              color="primary"
              :loading="loading_reenvio"
              @click="confirmarReenvio"
            >
              <v-icon left>mdi-send</v-icon>
              Reenviar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-overlay :value="progressBar">
      <v-progress-circular indeterminate size="64" color="accent"></v-progress-circular>
      </v-overlay>
    </div>
  </template>
  
  <script>
  //import XLSX from 'xlsx-style'
  import * as XLSX2 from 'xlsx'
  import { saveAs } from 'file-saver'
  import axios from 'axios'
  import { EventBus } from '@/event-bus'
  import router from '@/router'
  import RepOrderView from './RepOrderView'
  export default {
    data: () => ({
      search: '',
      newcmp: false,
      e1: 0,
      e2: 0,
      msj_proceso:'',
      progressBar1: false,
      overlay: false,
      step_error1: true,
      step_error2: true,
      step_error3: true,
      step_color1:"primary",
      step_color2:"primary",
      step_color3:"primary",
      listOr: true,
      dialog_new: false,
      btnG: true,
      valid: true,
      valid2: true,
      dialog: false,
      loading2: false,
      viewrepo: false,
      filters: {},
      api_tool_url: process.env.VUE_APP_API_TOOL_URL,
      tabs: 0,
      text: 'Lorem ipsum',
      NombreHoja1: '',
      NombreHoja2: '',
      loading: false,
      taberror: false,
      progressBar: false,
      mostrarTabs: false,
      ordenesConDatos: [],
      dialog_reenvio: false,
      itemReenvio: null,
      loading_reenvio: false,
      msj_reenvio: '',
      msj_reenvio_type: 'success',
      esPreprod: ['10.22.178.89', 'localhost'].includes(window.location.hostname),
      items: [
        {
          icon: 'mdi-account-box',
          text: 'Destinatarios'
        },       
        {
          icon: 'mdi-file-document',
          text: 'Mail'
        },
        {
          icon: 'mdi-alert-circle',
          text: 'Errores'
        }
      ],
      headers: [
        { text: 'Id', title: 'Id', value: 'RepOrder_id', align: 'center', sortable: true, key: 'RepOrder_id' },
        { text: 'Descripción', title: 'Descripción', value: 'RepOrder_Desc', align: 'center', sortable: true, key: 'RepOrder_Desc' },
        { text: 'Estado', title: 'Estado', value: 'RepOrderStatus_id', align: 'center', sortable: true, key: 'RepOrderStatus_id' },
        { text: 'Usuario Actualización', title: 'Usuario Actualización', value: 'LastOpRepUser_id', align: 'center', sortable: true, key: 'LastOpRepUser_id' },
        { text: 'Fecha Act', title: 'Fecha Act', value: 'RepEvent_Dt', align: 'center', sortable: true, key: 'RepEvent_Dt' },
        { text: 'Hora Act', title: 'Hora Act', value: 'RepEvent_Tm', align: 'center', sortable: true, key: 'RepEvent_Tm' },
        { text: 'Acción', value: 'action'}
      ],
      headers1:[
        { text: 'Agregar', key: 'selected',value: 'selected',sortable: false },
        { text: 'Id Usuario', key: 'ApiUser_id',value: 'ApiUser_id' },
        { text: 'Nombre', key: 'ApiUser_GivenName',value: 'ApiUser_GivenName' },
        { text: 'Email', key: 'ApiUser_EMail',value: 'ApiUser_EMail' },
        { text: 'Folio', key: 'ApiUser_Supplier',value: 'ApiUser_Supplier' },
        { text: 'Desc Proveedor', key: 'MotherSupplier_Desc',value: 'MotherSupplier_Desc' }
      ],
      headers2:[],
      headers3:[
        { text: 'Linea', key: 'Line',value: 'Line' },
        { text: 'Solapa', key: 'Solapa',value: 'Solapa' },
        { text: 'Error', key: 'Error',value: 'Error' }
      ],
      headers4:[
        { text: 'Folio', key: 'MotherSupplier_id',value: 'MotherSupplier_id' },
        { text: 'Desc Proveedor', key: 'MotherSupplier_Desc',value: 'MotherSupplier_Desc' },
        { text: 'Estado', key: 'RepOrderItemsStatus_id',value: 'RepOrderItemsStatus_id' },
        { text: 'Fecha', key: 'RepEvent_Dt',value: 'RepEvent_Dt' },
        { text: 'Hora', key: 'RepEvent_Tm',value: 'RepEvent_Tm' }
      ],
      headers5:[
        { text: 'N°', key: 'RepOrderItems_id',value: 'RepOrderItems_id' },
        { text: 'Descripción', key: 'RepOrderItems_Desc',value: 'RepOrderItems_Desc' },
        { text: 'Observación', key: 'RepOrderItems_Obs',value: 'RepOrderItems_Obs' },
        { text: 'Fecha', key: 'RepEvent_Dt',value: 'RepEvent_Dt' },
        { text: 'Hora', key: 'RepEvent_Tm',value: 'RepEvent_Tm' },
      ],
      headers6:[],
      ordenes: [
        { orden_id: 101, descripcion: 'Compra materiales A', estado: 'Pendiente' },
        { orden_id: 102, descripcion: 'Compra materiales B', estado: 'Completado' }
      ],
      subitems: [],
      subitems2: [],
      orderStore:[],
      RepOrderItems:[],
      itemsEnTabla:[],
      proveedores: [],
      RepOrderTemplate: [],
      RepOrder:[],
      RepOrder2:[],
      selectedDescription: '',
      destinatarios:[],
      data2:[],
      data3:[],
      errores: [],
      respuesta: '',
      token: sessionStorage.getItem('access_token'),
      user: sessionStorage.getItem('ApiUser_id'),
      hora: '',
      fechaHoy: new Date().toISOString().split('T')[0],
      editedIndex: -1,
      RepOrderTemplate2: {
        RepOrderTemplate2_id: 0
      },
      serverItems:[],
      filters: {
        RepGroup_id: '',
        EffectiveDate: '',
        ExpirationDate: '',
        LastOpRepUser_id: '',
        RepEvent_Dt: '',
        RepEvent_Tm: ''
      },
      files:[],
      files2:[],
      OrdenItem: {
        RepOrder_id: '',
        RepOrder_Desc: '',
        RepOrder_Text: '',
        RepOrderStatus_id: '1',
        CreationRepEvent_id: this.token,
        CreationRepUser_id: this.user,
        CreationRepEvent_Dt: this.fechaHoy,
        CreationRepEvent_Tm: '',
        RepEvent_id: this.token,
        LastOpRepUser_id: this.user,
        RepEvent_Dt: this.fechaHoy,
        RepEvent_Tm: '',
        RepOrderTemplate_id:''
      },
      editedItem:{
        ApiUser_id: '',
        ApiUser_GivenName: '',
        ApiUser_EMail: '',
        ApiUserType_id: 'P'
      },
      editedItemS: {
        ApiUser_id:'',
        ApiUser_Supplier:'',
        SupplierStart_Dt: new Date().toISOString().split('T')[0], 
        SupplierEnd_Dt: '9999-12-31'
      },
      RepOrderStatus:[],
      RepOrderItemsStatus:[],
      ReceiversItem: {
        MotherSupplier_id: '',
        RepOrder_id: '',
        RepOrderGroupReceivers_id: '',
        RepOrderItemsStatus_id: '1',
        RepEvent_id: this.token,
        LastOpRepUser_id: this.user,
        RepEvent_Dt: this.fechaHoy,
        RepEvent_Tm: ''
      },
      idRules: [
        v => !!v || 'Rol ID es requerido',
        v => (v && v.length <= 30) || 'Role ID debe tener menos de 30 caracteres',
      ],
      descRules: [
        v => !!v || 'Descripcion es requerida',
        v => (v && v.length <= 61) || 'Descripcion debe tener menos de 30 caracteres',
      ],
      emailRules: [
        v => !!v || 'El correo es requerido',
        v => /.+@.+\..+/.test(v) || 'El correo debe tener un formato válido'
      ],
      config: {
        headers: {
          //'Authorization': 'Bearer ' + sessionStorage.getItem('access_token'),
          "api-user": sessionStorage.getItem('ApiUser_id')
        }
      }
    }),
  
    computed: {
      formTitle () {
        return this.editedIndex === -1 ? 'Nuevo Proceso' : 'Editar Proceso'
      },
      destinatariosConClave() {
        // Devolvemos una copia con el idCompuesta SOLO PARA LA VISTA
        return this.destinatarios.map(item => ({
          ...item,
          idCompuesta: `${item.ApiUser_id}_${item.ApiUser_Supplier}`,
        }))
      },
      filteredItems() {
        if (!this.RepOrder || !Array.isArray(this.RepOrder)) return [];
  
        return this.RepOrder.filter(item => {
          return Object.keys(this.filters).every(key => {
            const filterValue = this.filters[key];
            if (!filterValue) return true;

            let itemValue = item[key];

            // Manejo especial para campos con descripción asociada
            if (key === 'RepOrderStatus_id') {
              const status = this.getRepOrderStatus(item.RepOrderStatus_id);
              itemValue = status && status.RepOrderStatus_Desc ? status.RepOrderStatus_Desc : '';
            }

            if (itemValue == null) return false;

            return itemValue.toString().toLowerCase().includes(filterValue.toLowerCase());
          });
        });
      }
    },
  
    watch: {
      dialog (val) {
        val || this.close()
      },
      'ReceiversItem.MotherSupplier_id'(nuevosIds) {
        // Actualiza la tabla con los proveedores seleccionados
        this.proveedores = this.proveedores.map(item => ({
          ...item,
          RepOrder_id: this.OrdenItem.RepOrder_id
        }));
        this.itemsEnTabla = this.proveedores.filter(p =>
          nuevosIds.includes(p.MotherSupplier_id)
        );
      }
    },
  
    created () {
      this.initialize()
    },
  
    methods: {
      exportarExcelCarga() {
        const Archivo = "Resultado_Carga_CMP"+this.OrdenItem.RepOrder_id+"_"+this.fechaHoy
        
        const sheets = [
          {
            nombre: 'Destinatarios',
            headers: this.headers1,
            data: this.destinatarios
          },
          {
            nombre: 'Data',
            headers: this.headers2,
            data: this.data2
          },
          {
            nombre: 'Errores',
            headers: this.headers3,
            data: this.errores
          }
        ]
        this.exportDataExcel(sheets, Archivo)
      },
      exportarExcelOrdenes() {
        const Archivo = "CMP-"+this.fechaHoy
        const filteredIds = this.filteredItems.map(item => item.RepOrder_id)
        const subitemsData = this.subitems.filter(sub => filteredIds.includes(sub.RepOrder_id))
        const subitemsData2 = subitemsData.map(sub => {
          const status = this.getRepOrderItemsStatus(sub.RepOrderItemsStatus_id)
          const status2 = this.getSupplier(sub.MotherSupplier_id)
          return {
            ...sub,
            status_desc: status && status.RepOrderItemsStatus_Desc ? status.RepOrderItemsStatus_Desc : '',
            MotherSupplier_Desc: status2 && status2.MotherSupplier_Desc ? status2.MotherSupplier_Desc : ''
          }
        })
        const OrdItem = this.filteredItems.map(sub => {
          const status = this.getRepOrderStatus(sub.RepOrderStatus_id)
          return {
            ...sub,
            RepOrderStatus_id: status && status.RepOrderStatus_Desc ? status.RepOrderStatus_Desc : ''
          }
        })
        console.log(OrdItem)
        const subheader=[
          { text: 'Orden ID', title: 'Orden ID', value: 'RepOrder_id', key: 'RepOrder_id'},
          { text: 'Proveedor', title: 'Proveedor', value: 'MotherSupplier_id', key: 'MotherSupplier_id'},
          { text: 'Proveedor Desc', title: 'Proveedor Desc', value: 'MotherSupplier_Desc', key: 'MotherSupplier_Desc'},
          { text: 'Status', title: 'Status', value: 'status_desc', key: 'status_desc'},
          { text: 'Fecha Status', title: 'Fecha Status', value: 'RepEvent_Dt', key: 'RepEvent_Dt'},
          { text: 'Hora Status', title: 'Hora Status', value: 'RepEvent_Tm', key: 'RepEvent_Tm'}
        ]
        const sheets = [
          {
            nombre: 'CMP',
            headers: this.headers,
            data: OrdItem
          },
          {
            nombre: 'Detalle',
            headers: subheader,
            data: subitemsData2
          }
        ]
        this.exportDataExcel(sheets, Archivo)
      },
      exportDataExcel(multipleSheets, Archivo) {
        const wb = XLSX2.utils.book_new()

        multipleSheets.forEach(sheet => {
          if (!Array.isArray(sheet.data) || sheet.data.length === 0) return

          const headers = sheet.headers.map(h => h.text)
          const rows = sheet.data.map(row =>
            sheet.headers.map(h => {
              const val = row[h.value]
              return val != null ? val : ''
            })
          )

          const ws = XLSX2.utils.aoa_to_sheet([headers, ...rows])

          // Estilos para los encabezados (fila 1)
          headers.forEach((_, colIndex) => {
            const cellRef = XLSX2.utils.encode_cell({ c: colIndex, r: 0 })
            if (!ws[cellRef]) return
            ws[cellRef].s = {
              font: { bold: true, color: { rgb: "FFFFFF" }, sz: 12 },
              fill: { fgColor: { rgb: "007ACC" } },
              alignment: { horizontal: "center", vertical: "center" },
              border: {
                top: { style: "thin", color: { rgb: "000000" } },
                bottom: { style: "thin", color: { rgb: "000000" } },
                left: { style: "thin", color: { rgb: "000000" } },
                right: { style: "thin", color: { rgb: "000000" } }
              }
            }
          })

          // Ajustar ancho columnas según longitud del header
          ws['!cols'] = headers.map(h => ({ wch: Math.max(10, h.length) }))

          XLSX2.utils.book_append_sheet(wb, ws, sheet.nombre || 'Hoja')
        })

        const wbout = XLSX2.write(wb, { bookType: 'xlsx', type: 'array', cellStyles: true })
        saveAs(new Blob([wbout], { type: 'application/octet-stream' }), Archivo + '.xlsx')
      },
      getFilterKey(column) {
        return column.title === 'Estado' ? 'RepOrderStatus_Desc' : column.value;
      },
      customFilter(value, search, item, column) {
        if (!search) return true;
          const lowerSearch = search.toLowerCase();

          if (column.value === 'RepOrderStatus_id') {
            const status = this.getRepOrderStatus(item.RepOrderStatus_id);
            const desc = status && status.RepOrderStatus_Desc
              ? status.RepOrderStatus_Desc.toLowerCase()
              : '';
            return desc.includes(lowerSearch);
          }

          return String(value).toLowerCase().includes(lowerSearch);
      },
      toggleSeleccionarTodo() {
        this.destinatarios.forEach(item => {
          item.selected = this.selectAll;
        });
      },
      mostrarProveedor(item) {
        if (!item) return ''
        return `${item.MotherSupplier_id} - ${item.MotherSupplier_Desc}`
      },
      getItemKey(item) {
        return `${item.ApiUser_id}_${item.ApiUser_Supplier}`;
      },
      generarUsuario() {
        const val = this.editedItem.ApiUser_GivenName
          .trim()
          .toLowerCase()
          .normalize("NFD")
          .replace(/[\u0300-\u036f]/g, "") // quitar acentos
          .replace(/[^a-z\s]/g, ""); // quitar símbolos

        const partes = val.split(/\s+/);

        if (partes.length >= 2) {
          const primero = partes[0];
          const ultimo = partes[partes.length - 1];
          const numero = Math.floor(0 + Math.random() * 99999999); // número aleatorio
          this.editedItem.ApiUser_id = `${primero}_${ultimo}_${numero}`;
          this.editedItemS.ApiUser_id = `${primero}_${ultimo}_${numero}`;
        } else {
          this.editedItemS.ApiUser_id = '';
          this.editedItem.ApiUser_id = '';
        }
      },
      nombreCompleto() {
        const val = this.editedItem.ApiUser_GivenName
        const partes = val
          .trim()
          .toLowerCase()
          .normalize("NFD") // Quita acentos
          .replace(/[\u0300-\u036f]/g, "") // Quita caracteres diacríticos
          .split(/\s+/)

        if (partes.length >= 2) {
          const primero = partes[0]
          const ultimo = partes[partes.length - 1]
          const numero = Math.floor(0 + Math.random() * 99999999)
          this.editedItem.ApiUser_id = `${numero}`
          this.editedItemS.ApiUser_id = `${numero}`
        } else {
          this.editedItem.ApiUser_id = ''
          this.editedItemS.ApiUser_id = ''
        }
      },
      exportData() {
        const headersCsv = this.headers.map(header => header.title).join(',')
        const rows = this.filteredItems.map(item =>this.headers.map(header => item[header.value]).join(','))
        
        const csvContent = [headersCsv, ...rows].join('\n')
        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' })
        const link = document.createElement('a')
        const url = URL.createObjectURL(blob)
        link.setAttribute('href', url)
        link.setAttribute('download', 'datos_exportados.csv')
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
      },
      initialize () {

        EventBus.$emit('actualizarNotificaciones')

        this.destinatarios = []
        this.data2 = []
        this.data3 = []
        this.errores = []
        this.files = []
        this.files2 = []
        this.tabs = 0
        this.RepOrderTemplate2.RepOrderTemplate2_id = 0
        this.mostrarTabs = false
        this.items = [
          {
            icon: 'mdi-account-box',
            text: 'Destinatarios'
          },       
          {
            icon: 'mdi-file-document',
            text: 'Mail'
          },
          {
            icon: 'mdi-alert-circle',
            text: 'Errores'
          }
        ]

        this.OrdenItem.RepOrder_id = ''
        this.OrdenItem.RepOrder_Desc= ''
        this.OrdenItem.RepOrder_Text= ''
        this.OrdenItem.RepOrderStatus_id= '1'
        this.OrdenItem.CreationRepEvent_id= this.token
        this.OrdenItem.CreationRepUser_id= this.user
        this.OrdenItem.CreationRepEvent_Dt= this.fechaHoy
        this.OrdenItem.CreationRepEvent_Tm= ''
        this.OrdenItem.RepEvent_id= this.token
        this.OrdenItem.LastOpRepUser_id= this.user
        this.OrdenItem.RepEvent_Dt= this.fechaHoy
        this.OrdenItem.RepEvent_Tm= ''

        this.editedItem.ApiUser_id= '',
        this.editedItem.ApiUser_GivenName= '',
        this.editedItem.ApiUser_EMail= '',
        this.editedItem.ApiUserType_id= 'P'

        this.editedItemS.ApiUser_id='',
        this.editedItemS.ApiUser_Supplier='',
        this.editedItemS.SupplierStart_Dt= this.fechaHoy, 
        this.editedItemS.SupplierEnd_Dt= '9999-12-31'

        this.ReceiversItem.RepEvent_id= this.token
        this.ReceiversItem.LastOpRepUser_id= this.user
        this.ReceiversItem.RepEvent_Dt= this.fechaHoy
        this.listOr = true
        this.loading2 = false
        this.loading = true
        this.newcmp = false

        this.modoSimulacion = false

        axios.post(this.api_tool_url + '/get_RepOrderId', {}, this.config)
          .then(response => {
            this.OrdenItem.RepOrder_id = response.data.ResultRows.RepOrderId
          })
          .catch(error => {
            alert(error.response.data.message)
        })

        axios.post(this.api_tool_url + '/get_RepOrderItemsStatus', {}, this.config)
        .then(response => {
          this.RepOrderItemsStatus = response.data.ResultRows
        })
        .catch(error => {
          this.RepOrderItemsStatus = []
          alert(error.response.data.message)
        })

        axios.post(this.api_tool_url + '/get_RepOrderStatus', {}, this.config)
        .then(response => {
          this.RepOrderStatus = response.data.ResultRows
        })
        .catch(error => {
          this.RepOrderStatus = []
          alert(error.response.data.message)
        })

        axios.post(this.api_tool_url + '/get_RepOrder', {}, this.config)
        .then(response => {
          this.RepOrder = response.data.ResultRows

          axios.post(this.api_tool_url + '/get_RepOrderDataExcel_ids', {}, this.config)
          .then(response => {
            this.ordenesConDatos = response.data.ResultRows.map(Number)
          })
          .catch(() => {
            this.ordenesConDatos = []
          })
        })
        .catch(error => {
          this.RepOrder = []
          alert(error.response.data.message)
        })

        axios.post(this.api_tool_url + '/get_RepOrderGroupReceivers', {}, this.config)
        .then(response => {
          this.subitems = response.data.ResultRows

        })
        .catch(error => {
          this.subitems = []
          alert(error.response.data.message)
        })

        axios.post(this.api_tool_url + '/get_RepOrderTemplate', {}, this.config)
        .then(response => {
          this.RepOrderTemplate = response.data.ResultRows
        })
        .catch(error => {
          this.RepOrderTemplate = []
          alert(error.response.data.message)
        })

        axios.post(this.api_tool_url + '/get_MotherSupplier', {}, this.config)
        .then(response => {
          this.proveedores = response.data.ResultRows
          this.loading = false
        })
        .catch(error => {
          this.proveedores = []
          alert(error.response.data.message)
        })
        
      },

      updateDescription() {
        const item = this.RepOrderTemplate.find(t => t.RepOrderTemplate_id === this.RepOrderTemplate2.RepOrderTemplate2_id);
        this.OrdenItem.RepOrder_Text = item ? item.RepOrderTemplate_Text : '';
      },
      newtItem() {
        this.dialog = true
      },
      // agregarProducto() {
      //   const item = this.proveedores.find(p => p.id === this.selectedItemToAdd);
      //   if (item && !this.itemsEnTabla.find(p => p.id === item.id)) {
      //     this.itemsEnTabla.push(item)
      //   }
      // },
      agregarNuevo(){
        this.newcmp = true
        this.listOr = false
      },
      listaCMP(){
        this.newcmp = false
        this.listOr = true
        this.initialize()
      },
      onCancel(item){
        const filter = {
          token: this.token,
          cmp_id: item.RepOrder_id,
          user: this.user
        }
        this.viewrepo = false
        this.progressBar = true
        axios.post(this.api_tool_url + '/finalizar_orden', filter, this.config)
        .then(response => {
          if(response.data.ResultRows.length > 0){
            axios.post(this.api_tool_url + '/get_RepOrder', {}, this.config)
            .then(response => {
              this.RepOrder = response.data.ResultRows
              this.progressBar = false
            })
            .catch(error => {
              this.RepOrder = []
              alert(error.response.data.message)
            })
          }
        })
        .catch(error => {
            alert(error.response.data.message)
        })

      },
      enviarRespuesta(MotherSupplier,RepOrder2){
        const id = RepOrder2.RepOrder_id
        const MotherSupplier_Desc = this.getSupplier(MotherSupplier).MotherSupplier_Desc
        this.loading= true

        const DescFolio_id = this.subitems2.filter(item => {
          const supplier = this.getSupplier(item.MotherSupplier_id);
          return supplier && supplier.MotherSupplier_Desc === MotherSupplier_Desc;
        }).map(item => item.MotherSupplier_id);

        const ahora = new Date();
        const horas = ahora.getHours().toString().padStart(2, '0');
        const minutos = ahora.getMinutes().toString().padStart(2, '0');
        const segundos = ahora.getSeconds().toString().padStart(2, '0');
        this.hora = `${horas}:${minutos}:${segundos}`;

        let data2 = new FormData();
        

        const RepOrderTemplate_Descr = this.getTemplate(this.RepOrder2.RepOrderTemplate_id).RepOrderTemplate_Desc
        

        const filter = {
          RepOrder_id: id,
          RepOrder: RepOrder2,
          MotherSupplier_id: DescFolio_id,
          MotherSupplier_Desc: MotherSupplier,
          RepEvent_Tm: this.hora,
          RepEvent_id: this.token,
          LastOpRepUser_id: this.user,
          Usuario_Logistico: this.$store.state.ApiUser_GivenName,
          RepEvent_Dt: this.fechaHoy,
          RepOrder_Text: this.respuesta,
          RepOrderTemplate_Desc: RepOrderTemplate_Descr,
          File: data2
        }
        data2.append('file', document.getElementById('file2').files[0]);
        data2.append('RepOrder_id', id);
        data2.append('RepOrder', RepOrder2);
        data2.append('RepOrder_Desc',RepOrder2.RepOrder_Desc);
        data2.append('CreationRepEvent_Dt',RepOrder2.CreationRepEvent_Dt);
        data2.append('MotherSupplier_id', DescFolio_id);
        data2.append('MotherSupplier_Desc', MotherSupplier);
        data2.append('RepEvent_Tm', this.hora);
        data2.append('RepEvent_id', this.token);
        data2.append('LastOpRepUser_id', this.user);
        data2.append('Usuario_Logistico', this.$store.state.ApiUser_GivenName);
        data2.append('RepEvent_Dt', this.fechaHoy);
        data2.append('RepOrder_Text', this.respuesta);
        data2.append('RepOrderTemplate_Desc', RepOrderTemplate_Descr);

        axios.post(this.api_tool_url + '/EnviarResp', data2, this.config)
        .then(response => {
          if(response.data.ResultRows === 'OK'){
            this.respuesta = ''
            this.initialize()
            this.viewrepo = false
            this.loading = false
          }
        })
        .catch(error => {
          alert(error.response.data.message)
        })

      },
      GetRepOrder(item) {
        const id = item.RepOrder_id
        const filter = {
          RepOrder_id: id
        }
        this.RepOrder2=this.RepOrder.find(r => r.RepOrder_id === id)
        this.subitems2=this.subitems.filter(sub => sub.RepOrder_id === id)
        this.e2=this.RepOrder2.RepOrderStatus_id
        this.viewrepo = true
        axios.post(this.api_tool_url + '/get_RepOrderItems', filter, this.config)
        .then(response => {
          this.RepOrderItems = response.data.ResultRows
        })
        .catch(error => {
          this.RepOrderItems = []
          alert(error.response.data.message)
        })
      },
      editOrder(item) {
        const id = item.RepOrder_id
        router.replace({
          name: 'RepOrder',
          params: {
            token: this.token,
            id: id
          }
        });
      },
      getTemplate(statusId) {
        return this.RepOrderTemplate.find(s => s.RepOrderTemplate_id === statusId) || {}
      },
      getSupplier(statusId) {
        return this.proveedores.find(s => s.MotherSupplier_id === statusId) || {}
      },
      getRepOrderStatus(statusId) {
        return this.RepOrderStatus.find(s => s.RepOrderStatus_id === statusId) || {}
      },
      getRepOrderItemsStatus(statusId) {
        return this.RepOrderItemsStatus.find(s => s.RepOrderItemsStatus_id === statusId) || {}
      },
      getSubitems(orden_id) {
        return this.subitems.filter(sub => sub.RepOrder_id === orden_id)
      },
      save () {
        this.editedItem.ApiUserType_id = 'P'
        this.loading2 = true
        axios.post(this.api_tool_url + '/ins_user', this.editedItem, this.config)
        .then(response => {
          if(response.data.ResultRows.length >= 1){
            axios.post(this.api_tool_url + '/upd_ins_userMotherSupplier2', this.editedItemS, this.config)
            .then(response => {
              this.close()
            })
            .catch(error => {
              alert(error.response.data.message)
            })
          }
        })
        .catch(error => {
          alert(error.response.data.message)
        })
      },
      carga() {
        this.btn = true
        this.progressBar = true
        this.msj_proceso = "Por favor aguarde un momento mientras se procesa la solicitud. ¡No cerrar esta ventana!"
        let data = new FormData();
        this.mvm = []
        this.destinatarios = []
        this.headers2 = []
        this.data2 = []
        this.headers6 = []
        this.data3 = []
        this.errores = []
        this.items = [
          {
            icon: 'mdi-account-box',
            text: 'Destinatarios'
          },       
          {
            icon: 'mdi-file-document',
            text: 'Mail'
          },
          {
            icon: 'mdi-alert-circle',
            text: 'Errores'
          }
        ]
        this.Observaciones = []
        this.tabs = 0
        this.taberror = false
        this.mostrarTabs = false
        data.append('file', document.getElementById('file').files[0]);
        data.append('token', this.token);
        data.append('cmp_id', this.OrdenItem.RepOrder_id);
        data.append('user', this.user);
        
        axios.post(this.api_tool_url + '/fileUploadCMP2', data, this.config)
        .then(response => {
          this.headers2 = response.data.ResultHeader
          const hojas = Object.keys(response.data.ResultHeader);
          if(hojas && hojas.length >= 1) {
            // this.destinatarios = response.data.ResultUsers
            const todos = response.data.ResultUsers || []
            this.destinatarios = todos.filter(item => this.tieneMailValido(item))
            this.destinatarios.forEach(item => {
              this.$set(item, 'selected', false); // necesario para que Vue lo reactive
              this.$set(item, 'idCompuesta', `${item.ApiUser_id}_${item.ApiUser_Supplier}`);
            });
            this.NombreHoja1 = hojas[0]
            this.headers2 = response.data.ResultHeader[hojas[0]]
            this.data2 = response.data.ResultRows[hojas[0]]
            if (hojas.length > 1) {
              this.NombreHoja2 = hojas[1]
              this.headers6 = response.data.ResultHeader[hojas[1]]
              this.data3 = response.data.ResultRows[hojas[1]]
            }
            const insertIndex = 1; 
            const itemsDatos = hojas.map((hoja, i) => ({
              icon: 'mdi-database',
              text: `Datos - ${hoja}`
            }));
            this.items.splice(insertIndex, 0, ...itemsDatos);
            this.errores =  response.data.ResultError
            if(response.data.ResultError.length > 0  ){
              if (hojas.length > 1){
                this.tabs = 4
              }
              else{
                this.tabs = 3
              }
              this.taberror = true
            }
            this.Observaciones= response.data.ResultError
            this.mostrarTabs = true
            this.progressBar = false
            this.btnG = false
            
            this.msj_proceso = 'Se realizo la comunicación correctamente.'
          }
          else {
            this.progressBar = false
            this.loading = false
            this.msj_proceso = error
          }
          this.btn = false

          axios.post(this.api_tool_url + '/get_RepOrderDataExcel_ids', {}, this.config)
          .then(r => { this.ordenesConDatos = r.data.ResultRows })
        })
        .catch(error => {
          this.btn = false
          this.progressBar = false
          if (error.response && error.response.data && error.response.data.message) {
            this.msj_proceso = error.response.data.message;
          } 
          else 
          {
            this.msj_proceso = 'Ocurrió un error al procesar el archivo.';
          }
          this.active = true
        })
                    
      },
      generar(){
        this.newcmp = false
        this.listOr = true
        this.loading = true
      },
      editItem (item) {
        this.editedIndex = this.RepOrderProcess.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialog = true
      },
  
      deleteItem (item) {
        const index = this.RepOrderProcess.indexOf(item)
        confirm('¿Confirma la eliminación del registro?') && this.deleteUserMenu(index)
      },
  
      deleteUserMenu(index) {
        let usermenus_tmp = this.RepOrderProcess[index]
        //delete usermenus_tmp.RepOrderProcess_id
        axios.post(this.api_tool_url + '/del_RepOrderProcess', usermenus_tmp, this.config)
          .then(response => {
            this.RepOrderProcess.splice(index, 1)
            this.close()
            })
          .catch(error => {
            this.RepOrderProcess = []
            alert(error.response.data.message)
            })
      },
  
      close () {
        this.dialog = false
        this.dialog_new = false
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        }, 300)
      },
  
      GenerarCMP(endpointMail = '/SendMailCMP2') {
        
        this.dialog_new = true
        const ahora = new Date();
        const horas = ahora.getHours().toString().padStart(2, '0');
        const minutos = ahora.getMinutes().toString().padStart(2, '0');
        const segundos = ahora.getSeconds().toString().padStart(2, '0');
        this.hora = `${horas}:${minutos}:${segundos}`;

        this.OrdenItem.RepEvent_Tm = this.hora
        this.OrdenItem.RepOrderTemplate_id = this.RepOrderTemplate2.RepOrderTemplate2_id
        const RepOrderTemplate_Descr = this.getTemplate(this.RepOrderTemplate2.RepOrderTemplate2_id).RepOrderTemplate_Desc
        const folios_new  = this.destinatarios.filter(item => item.selected === true)
        
        const proveedoresUnicos = Array.from(
                      new Map(folios_new.map(p => [p.ApiUser_Supplier, p])).values()
        );

        const filter = {
          RepOrder_id: this.OrdenItem.RepOrder_id,
          RepEvent_id: this.token,
          LastOpRepUser_id: this.user,
          Usuario_Logistico: this.$store.state.ApiUser_GivenName,
          RepEvent_Dt: this.fechaHoy,
          RepEvent_Tm: this.hora,
          RepOrder: this.OrdenItem,
          RepOrderGroupReceivers: this.destinatarios.filter(item => item.selected === true),
          RepOrderData: this.data2,
          Header: this.headers2,
          RepOrderData2: this.data3,
          Header3: this.headers6,
          RepOrderTemplate_Desc: RepOrderTemplate_Descr,
          Hoja1Nombre: this.NombreHoja1,
          Hoja2Nombre: this.NombreHoja2
        }

        this.e1 = 1
        this.progressBar1 = true
        this.step_error1 = true
        this.step_error2 = true
        this.step_error3 = true
        this.step_color1 = "primary",
        this.step_color2 = "primary",
        this.step_color3 = "primary",
        this.msj_proceso = "Por favor aguarde un momento mientras se procesa la solicitud. ¡No cerrar esta ventana!"

        axios.post(this.api_tool_url + '/SendCMP', filter, this.config)
        .then(response => {
          if(response.data.ResultRows === 'OK'){
            this.e1 = 1
            this.step_color1 = "#008000"
            this.step_error1 = true
            this.progressBar1 = false
            this.msj_proceso = 'Se registro la comunicación correctamente.'
            this.e1 = 2
            this.progressBar1 = true
            
            // Comentado para agregar carga simulada sin envío
            // axios.post(this.api_tool_url + '/SendMailCMP2', filter, this.config)

            axios.post(this.api_tool_url + endpointMail, filter, this.config)
            .then(response => {
              if(response.data.ResultRows === 'OK') {
                this.e1 = 2
                this.step_color2 = "#008000"
                this.progressBar1 = false
                this.step_error2 = true
                this.msj_proceso = 'Se registraron los destinatarios correctamente.'
                
                this.e1 = 3
                this.progressBar1 = true
                this.msj_proceso = 'Finalizando Comunicación.'

                const filter2 = {RepOrder_id: this.OrdenItem.RepOrder_id}
                
                axios.post(this.api_tool_url + '/get_RepOrder', filter2, this.config)
                .then(response => {
                  if (response.data.ResultRows.length > 0){
                    this.e1 = 3
                    this.step_color3 = "#008000"
                    this.progressBar1 = false
                    this.step_error3 = true
                    this.msj_proceso = 
                    `Finalizo el envío de la comunicación.\n` +
                    `Orden de CMP: ${this.OrdenItem.RepOrder_id} - ${this.OrdenItem.RepOrder_Desc}.\n`
                    //  +`Proveedores:\n` +proveedoresUnicos.map(p => `\t${p.ApiUser_Supplier} - ${p.MotherSupplier_Desc}`).join('\n');
                    this.destinatarios = []
                    this.data2 = []
                    this.errores = []
                    this.files = []
                    this.tabs = 0
                    this.RepOrderTemplate2.RepOrderTemplate2_id = 0
                    this.mostrarTabs = false

                    this.OrdenItem.RepOrder_id = ''
                    this.OrdenItem.RepOrder_Desc= ''
                    this.OrdenItem.RepOrder_Text= ''
                    this.OrdenItem.RepOrderStatus_id= '1'
                    this.OrdenItem.CreationRepEvent_id= this.token
                    this.OrdenItem.CreationRepUser_id= this.user
                    this.OrdenItem.CreationRepEvent_Dt= this.fechaHoy
                    this.OrdenItem.CreationRepEvent_Tm= ''
                    this.OrdenItem.RepEvent_id= this.token
                    this.OrdenItem.LastOpRepUser_id= this.user
                    this.OrdenItem.RepEvent_Dt= this.fechaHoy
                    this.OrdenItem.RepEvent_Tm= ''

                    this.editedItem.ApiUser_id= '',
                    this.editedItem.ApiUser_GivenName= '',
                    this.editedItem.ApiUser_EMail= '',
                    this.editedItem.ApiUserType_id= 'P'

                    this.editedItemS.ApiUser_id='',
                    this.editedItemS.ApiUser_Supplier='',
                    this.editedItemS.SupplierStart_Dt= new Date().toISOString().split('T')[0], 
                    this.editedItemS.SupplierEnd_Dt= '9999-12-31'

                    this.initialize()
                    EventBus.$emit('actualizarNotificaciones')

                  }
                  else{
                    this.e1 = 3
                    this.step_color3 = "#C0392B"
                    this.step_error3 = false
                    this.progressBar1 = false
                    this.msj_proceso = 'Fallo la finalización de la orden.'
                  }
                })
                .catch(error => {
                  this.e1 = 3
                  this.step_color3 = "#C0392B"
                  this.step_error3 = false
                  this.progressBar1 = false
                  this.msj_proceso = 'Fallo la finalización de la orden.'
                  alert(error.response.data.message)
                })
                
              }
              else{
                this.e1 = 2
                this.step_color2 = "#C0392B"
                this.step_error2 = false
                this.progressBar1 = false
                this.msj_proceso = 'Fallo el registro de destinatarios.'
              }

            })
            .catch(error => {
              this.e1 = 2
              this.step_color2 = "#C0392B"
              this.step_error2 = false
              this.progressBar1 = false
              this.msj_proceso = 'Fallo el registro de destinatarios.'
              alert(error.response.data.message)
            })

          }
          else{
            this.e1 = 1
            this.step_color1 = "#C0392B"
            this.step_error1 = false
            this.progressBar1 = false
            this.msj_proceso = 'Fallo el registro la comunicación. '
            alert(response.data.ResultError)
          } 
        })
        .catch(error => {
          this.e1 = 1
          this.step_color1 = "#C0392B"
          this.step_error1 = false
          this.progressBar1 = false
          this.msj_proceso = 'Fallo el registro la comunicación.'
          alert(error.response.data.message)
        })
        
      },

      abrirReenvio(item) {
        this.itemReenvio  = item
        this.msj_reenvio  = ''
        this.dialog_reenvio = true
      },

      confirmarReenvio() {
        if (!this.itemReenvio) return
        this.loading_reenvio = true
        this.msj_reenvio     = ''

        const filter = {
          RepOrder_id:       this.itemReenvio.RepOrder_id,
          token:             this.token,
          user:              this.user,
          Usuario_Logistico: this.$store.state.ApiUser_GivenName
        }

        axios.post(this.api_tool_url + '/ReenviarMailCMP', filter, this.config)
          .then(response => {
            this.loading_reenvio = false
            if (response.data.ResultRows === 'OK') {
              this.msj_reenvio      = 'Mail reenviado correctamente.'
              this.msj_reenvio_type = 'success'
              axios.post(this.api_tool_url + '/get_RepOrderDataExcel_ids', {}, this.config)
                .then(r => { this.ordenesConDatos = r.data.ResultRows })
              setTimeout(() => { this.dialog_reenvio = false }, 1500)
            } else {
              this.msj_reenvio      = 'Error al reenviar: ' + (response.data.ResultError || '')
              this.msj_reenvio_type = 'error'
            }
          })
          .catch(error => {
            this.loading_reenvio  = false
            this.msj_reenvio      = error.response.data.message || 'Error al reenviar el mail.'
            this.msj_reenvio_type = 'error'
          })
      },
      debeVerReenvio(item) {
        const resultado = item && 
          item.RepOrderStatus_id === 1 && 
          this.ordenesConDatos.includes(item.RepOrder_id)
        // console.log(`item ${item.RepOrder_id} status:${item.RepOrderStatus_id} enLista:${this.ordenesConDatos.includes(item.RepOrder_id)} resultado:${resultado}`)
        return resultado
      },

      tieneMailValido(item) {
        const mail = item.ApiUser_EMail
        if (mail === null || mail === undefined) return false

        const valor = String(mail).trim()
        if (valor === '' || ['none', 'null', 'nan', 'undefined'].includes(valor.toLowerCase())) {
          return false
        }

        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(valor)
      },
    }
  }
  </script>
  
  <style scoped>
  .custom-header {
    background-color: #1976d2; /* Azul Vuetify */
    color: white;
    font-weight: bold;
    text-transform: uppercase;
  }
  .tab-active {
  color: red !important;
  }
  .tab-inactive {
    color: black !important;
  }
  </style>


// WEBPACK FOOTER //
// src/components/RepOrderForm.vue